
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom';

import i18n from '../../../i18n/client-i18n';
import './index.global.scss';
import { createArenaSplitPageApp } from './createArenaSplitPageApp';
import { LogoUrlGenerator } from '@wix/branding-client-lib';
import { initSessionId, biLogSafe } from '../../services/biService';
import origins from '../../consts/origins';
import { isReactWebview } from '../../services/userAgentDetector';

const initialI18n = window.__INITIAL_I18N__;
const experiments = window.__EXPERIMENTS__;
const referralAdditionalInfo = window.__REFERRAL_ADDITIONAL_INFO__;
const basename = window.__BASE_PATH__;
const debugApp = window.__DEBUG_APP__;
const companyDetails = window.__COMPANY_DETAILS__;
const location = window.location;
const queryParams = window.__QUERY_PARAMS__;
const i19n = i18n(initialI18n);
const logoUrlGenerator = new LogoUrlGenerator({ protocol: location.protocol, host: location.host, mountPoint: basename, debugApp, experiments });

initSessionId({ screenName: 'arenaSplitPage' });

let linkToArena = `https://www.wix.com/marketplace/dynamic-brief?entry=general&serviceType=5&innerType=6&origin=logo_maker_split`;
if (experiments['specs.marketplace.logoRedirect'] === 'true') {
  linkToArena = `https://www.wix.com/marketplace/hire/graphic-designer/logo-design-services?no-loc=true`;
}

function sendBi(eventName, params) {
  try {
    biLogSafe(biLog => {
      biLog(eventName, { ...params });
    });
  } catch (error) {
    console.error(`[ArenaOnBoardingController.js:sendBi] error`, error.message);
  }
}

function navigateWindow (url, isNewWindow) {
  if (isNewWindow) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};

function goToOnBoarding () {
  sendBi('arenaSplitPageLogoClick', {});
  const { companyName } = companyDetails;

  const additionalParams = { ...queryParams };
  additionalParams.referralAdditionalInfo = origins.ARENA_SPLIT_PAGE;

  // We add the debugApp queryParams on logoUrlGenerator navigation functions
  delete additionalParams.debugApp;

  const finalParams = Object.entries(additionalParams).map(([key, value]) => {
    return { key, value };
  });
  let onboardingUrl = '';
  if (companyName) {
    onboardingUrl = logoUrlGenerator.getIndustryOnboardingUrl(finalParams);
  } else {
    onboardingUrl = logoUrlGenerator.getHomePageUrl(finalParams);
  }
  navigateWindow(onboardingUrl, false);
};

function goToArena () {
  navigateWindow(linkToArena, true);
};

if (isReactWebview()) {
  goToOnBoarding();
} else {
  const app = createArenaSplitPageApp({
    i19n,
    experiments,
    goToOnBoarding,
    goToArena,
    sendBi,
    referralAdditionalInfo
  });

  ReactDOM.hydrate(app, document.getElementById('root'));
}